/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { IndDlpCstLoginDto } from '../model/indDlpCstLoginDto';
import { IndDlpDlrLoginDto } from '../model/indDlpDlrLoginDto';
import { IndDlpLoginDto } from '../model/indDlpLoginDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class IndDlpLoginControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * customerLogin
     * 
     * @param indDlpCstLoginDto indDlpCstLoginDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerLoginUsingPOST(indDlpCstLoginDto: IndDlpCstLoginDto, observe?: 'body', reportProgress?: boolean): Observable<IndDlpCstLoginDto>;
    public customerLoginUsingPOST(indDlpCstLoginDto: IndDlpCstLoginDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IndDlpCstLoginDto>>;
    public customerLoginUsingPOST(indDlpCstLoginDto: IndDlpCstLoginDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IndDlpCstLoginDto>>;
    public customerLoginUsingPOST(indDlpCstLoginDto: IndDlpCstLoginDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (indDlpCstLoginDto === null || indDlpCstLoginDto === undefined) {
            throw new Error('Required parameter indDlpCstLoginDto was null or undefined when calling customerLoginUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IndDlpCstLoginDto>(`${this.basePath}/dlp/customer/login`,
            indDlpCstLoginDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * dealerLogin
     * 
     * @param loginCreds loginCreds
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dealerLoginUsingPOST(loginCreds: IndDlpDlrLoginDto, observe?: 'body', reportProgress?: boolean): Observable<IndDlpLoginDto>;
    public dealerLoginUsingPOST(loginCreds: IndDlpDlrLoginDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IndDlpLoginDto>>;
    public dealerLoginUsingPOST(loginCreds: IndDlpDlrLoginDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IndDlpLoginDto>>;
    public dealerLoginUsingPOST(loginCreds: IndDlpDlrLoginDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (loginCreds === null || loginCreds === undefined) {
            throw new Error('Required parameter loginCreds was null or undefined when calling dealerLoginUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IndDlpLoginDto>(`${this.basePath}/dlp/dealer/login`,
            loginCreds,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
